import { axiosInstance as axios } from "./axiosInstance";

const URL = `/api/v2/answers`;

export const submitIntro = intro => {
    const data = {
        intro
    }
    return axios.post(`${URL}/intro`, data);
}

export const submitPassion = passion => {
    const data = {
        passion
    }
    return axios.post(`${URL}/passion`, data);
}

export const submitPeople = people => {
    const data = {
        people
    }
    return axios.post(`${URL}/people`, data);
}

export const submitImpact = impact => {
    const data = {
        impact
    }
    return axios.post(`${URL}/impact`, data);
}

export const submitProduct = product => {
    const data = {
        product
    }
    return axios.post(`${URL}/product`, data);
}

export const submitVision = vision => {
    const data = {
        vision
    }
    return axios.post(`${URL}/vision`, data);
}

export const submitValues = values => {
    const data = {
        values
    }
    return axios.post(`${URL}/values`, data);
}

export const submitLook = look => {
    const data = {
        look
    }
    return axios.post(`${URL}/look`, data);
}

export const submitTone = tone => {
    const data = {
        tone
    }
    return axios.post(`${URL}/tone`, data);
}

export const submitAttributes = attributes => {
    const data = {
        attributes
    }
    return axios.post(`${URL}/attributes`, data);
}

export const submitCompetition = competition => {
    const data = {
        competition
    }
    return axios.post(`${URL}/competition`, data);
}

export const submitTrends = trends => {
    const data = {
        trends
    }
    return axios.post(`${URL}/trends`, data);
};
